import { tokens } from '../../tokens';
import { MrcPhase } from '../../txHelpers';

/**
 * The MRC phase-flow timeline — a vertical list of every MRC phase
 * (INITIALISED / PENDING / RESET …), each tagged with its timeframe and a
 * from/to detail block. Shared by the expanded-transaction MRC deep dive
 * and the live-state MRC deep dive.
 */
const MrcPhaseFlow = ({ phases }: { phases: MrcPhase[] }) => (
  <div
    style={{
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <div
      style={{
        fontSize: 14,
        color: tokens.amber,
        fontFamily: tokens.fontMono,
        letterSpacing: '0.18em',
        marginBottom: 24,
        fontWeight: 700,
        flexShrink: 0,
      }}
    >
      MRC PHASE FLOW
    </div>
    <div
      className="nc-no-scrollbar"
      style={{
        position: 'relative',
        paddingLeft: 26,
        paddingTop: 8,
        paddingBottom: 8,
        flex: 1,
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: 7,
          top: 10,
          bottom: 10,
          width: 1,
          background: 'rgba(255,255,255,0.15)',
        }}
      />
      {phases.map((phase, index) => (
        <div
          key={`${phase.name}_${index}`}
          style={{
            position: 'relative',
            marginBottom: index === phases.length - 1 ? 0 : 20,
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              position: 'relative',
            }}
          >
            <div
              style={{
                position: 'absolute',
                left: -26,
                top: '50%',
                transform: 'translateY(-50%)',
                width: 15,
                height: 15,
                borderRadius: '50%',
                background: '#000',
                border: `2px solid ${phase.color}`,
              }}
            />
            <div
              style={{
                fontSize: 13,
                color: phase.color,
                fontFamily: tokens.fontMono,
                letterSpacing: '0.15em',
                fontWeight: 700,
                lineHeight: 1,
              }}
            >
              {phase.name}
            </div>
            <div
              style={{
                fontSize: 11,
                color: tokens.textTertiary,
                fontFamily: tokens.fontMono,
                letterSpacing: '0.08em',
                fontWeight: 600,
                lineHeight: 1,
                padding: '3px 7px',
                borderRadius: 3,
                background: 'rgba(255,255,255,0.06)',
              }}
            >
              {phase.timeFrame}
            </div>
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '4px 16px',
              marginTop: 10,
              fontFamily: tokens.fontMono,
            }}
          >
            <div
              style={{
                fontSize: 11,
                color: tokens.textTertiary,
                fontWeight: 600,
              }}
            >
              FROM
            </div>
            <div
              style={{
                fontSize: 11,
                color: tokens.textTertiary,
                fontWeight: 600,
              }}
            >
              TO
            </div>
            <div style={{ fontSize: 13, color: tokens.textSecondary }}>
              {phase.startDate}
            </div>
            <div style={{ fontSize: 13, color: tokens.textSecondary }}>
              {phase.endDate}
            </div>
            <div
              style={{
                fontSize: 15,
                color: tokens.textPrimary,
                fontWeight: 600,
              }}
            >
              {phase.startPrice}
            </div>
            <div
              style={{
                fontSize: 15,
                color: tokens.textPrimary,
                fontWeight: 600,
              }}
            >
              {phase.endPrice}
            </div>
            <div style={{ fontSize: 12, color: tokens.textTertiary }}>
              rsi {phase.startRsi}
            </div>
            <div style={{ fontSize: 12, color: tokens.textTertiary }}>
              rsi {phase.endRsi}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default MrcPhaseFlow;
